import React from "react";
import { Button } from "../../components/ui/button";
import useSlider from "../../hooks/useSlider";
import ReducedTime from "../../assets/images/reducedTime.png";
import CustomeClearence from "../../assets/images/customeClearence.png";
import TimeTracking from "../../assets/images/timeTracking.png";
import SupplyChain from "../../assets/images/supplyChain.png";

const testimonials = [
  {
    id: 1,
    quote: "Reduced documentation time by 70%",
    company: "ABC Logistics",
    stat: "500+ shipments monthly",
    imageType: "warehouse",
  },
  {
    id: 2,
    quote: "Seamless customs clearance every time",
    company: "Global Trade Co.",
    stat: "98% compliance rate",
    imageType: "dashboard",
  },
  {
    id: 3,
    quote: "Real-time tracking changed our business",
    company: "Pacific Imports",
    stat: "50+ countries served",
    imageType: "documents",
  },
  {
    id: 4,
    quote: "Best investment for our supply chain",
    company: "EuroConnect Ltd.",
    stat: "30% cost reduction",
    imageType: "map",
  },
];

const imageMap = {
  warehouse: ReducedTime,
  dashboard: CustomeClearence,
  documents: TimeTracking,
  map: SupplyChain,
};

export const FeatureSlider = () => {
  const { currentIndex, goToSlide, setIsPaused } = useSlider(
    testimonials.length,
  );

  return (
    <div className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl lg:text-4xl font-bold text-center text-slate-900 mb-12">
          Trusted by Global Trade Leaders
        </h2>

        <div
          className="relative overflow-hidden rounded-2xl"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="w-full flex-shrink-0 px-4">
                <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-8 lg:p-12 shadow-lg">
                  <div className="flex flex-col lg:flex-row items-center gap-8">
                    <img
                      src={imageMap[testimonial.imageType]}
                      alt={`${testimonial.imageType} visual`}
                      className={`w-32 h-32 lg:w-48 lg:h-48 object-cover border-2 border-dashed border-slate-300 rounded-xl`}
                    />
                    <div className="flex-1 text-center lg:text-left">
                      <blockquote className="text-2xl lg:text-3xl font-bold text-slate-900 mb-4">
                        "{testimonial.quote}"
                      </blockquote>
                      <div className="flex items-center justify-center lg:justify-start gap-4 mb-2">
                        <div className="w-12 h-12 bg-slate-200 rounded-full flex items-center justify-center">
                          <span className="text-slate-600 font-semibold">
                            {testimonial.company.substring(0, 2).toUpperCase()}
                          </span>
                        </div>
                        <div>
                          <p className="font-semibold text-slate-900">
                            {testimonial.company}
                          </p>
                          <p className="text-sm text-slate-600">
                            {testimonial.stat}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {testimonials.map((_, index) => (
            <Button
              key={index}
              variant="outline"
              size="sm"
              onClick={() => goToSlide(index)}
              className={`w-2 h-2 rounded-full p-0 transition-all duration-200 ${currentIndex === index ? "bg-blue-600 border-blue-600 w-8" : "bg-slate-300 border-slate-300 hover:bg-slate-400"}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeatureSlider;
